<template>
    <div>
        <div id="page">
            <div class="page-content">


                <div class="card header-card shape-rounded" data-card-height="150">
                    <div class="card-overlay bg-highlight opacity-95"></div>
                    <div class="card-overlay dark-mode-tint"></div>
                    <div class="card-bg bg-20"></div>
                </div>
                <div class="card card-style text-center" style="margin-top:100px">
                    <div >
                        <div class="content pb-2" v-if="status==1">
                            <div class="mb-5">
                                <i class="fa fa-exclamation-triangle color-red1-dark fa-5x pt-3 icon-size"></i>
                            </div>
                            <p v-if="showInBazar==false">
                                کاربر گرامی، جهت استفاده از تمامی امکانات تَسکینو، می بایست
                                <b class="text-danger">اشتراک فعال</b>

                                داشته باشید .در صورت عدم تهیه اشتراک
                                <b class="text-warning">برخی از امکانات</b>
                                برای شما فعال نمی باشد.
                            </p>

                            <div class="row mb-0">
                                <div class="col-12">
                                    <a href="/Order" class="btn btn-m btn-full rounded-s shadow-xl font-900 bg-highlight add-button">
                                        <i class="fa fa-user-clock ml-2"></i>
                                        تمدید اشتراک
                                    </a>
                                </div>

                            </div>
                        </div>
                        <div class="content pb-2" v-if="status==0">
                            <div class="mb-5">
                                <i class="fa fa-exclamation-triangle color-red1-dark fa-5x pt-3 icon-size"></i>
                            </div>
                            <p>کاربر گرامی، جهت استفاده از تمامی امکانات تسکینو ، می بایست اشتراک فعال داشته باشید . در صورت عدم تهیه اشتراک برخی از امکانات برای شما فعال نمی باشد..</p>
                            <div class="row mb-0">
                                <div class="col-12">
                                    <a href="/UserOrder" class="btn btn-m btn-full rounded-s shadow-xl font-900 bg-highlight add-button">
                                        <i class="fa fa-user-clock ml-2"></i>
                                        تمدید اشتراک
                                    </a>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div class="content pb-2" v-if="status==2">
                        <div class="mb-5">
                            <i class="fa fa-exclamation-triangle color-red1-dark fa-5x pt-3 icon-size"></i>
                        </div>
                        <p>کاربر گرامی، حساب کاربری شما توسط سرپرست تیم غیرفعال شده است.</p>
                    </div>

                    <div class="content pb-2 mt-0">
                        <div class="row">
                            <div class="col-12">
                                <a href="/" class="btn btn-m btn-full rounded-s shadow-xl font-900 bg-green1-light add-button">
                                    <i class="fa fa-redo ml-2"></i>
                                    بازگشت به صفحه اصلی
                                </a>
                            </div>

                        </div>
                        <div class="row">
                            <div class="col-12">
                                <button class="btn btn-success w-100 btn-m btn-full rounded-s shadow-xl font-900 add-button" v-on:click="CheckIsEnable()">
                                    <i class="fa fa-search ml-2"></i>
                                    بررسی مجدد
                                </button>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <button class="btn btn-outline-danger w-100 btn-m btn-full rounded-s shadow-xl font-900 add-button" @click.prevent="SignOutUser()">
                                    <i class="fa fa-sign-out-alt ml-2"></i>
                                    خروج از حساب کاربری
                                </button>
                            </div>
                        </div>
                    </div>
                </div>




            </div>

        </div>


    </div>
</template>

<script>
    export default {
        data() {
            return {
                showInBazar: false,
                info: null,
                status: this.$route.params.adminOrUser
            }
        },
        created() {
            //this.$http
            //    .get("Task/GetPayInBazarAllowAnonymous")
            //    .then((data) => {
            //        var res = data.data;
            //        this.showInBazar = res.isSuccess;
            //    });
        },
        methods: {
            CheckIsEnable() {
                console.log("log");
                window.location = "/";
            },
            SignOutUser() {
                this.$store.dispatch("SignOutUser");
            },
        }
    }
</script>